// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Fej6","rootSmall":"AddTileButton_rootSmall__117gT"};